const ViewType = {
	Page: 'page',
	Drawer: 'drawer',
};

export default ViewType;
